import React from 'react';
import { Reveal } from './MotionPrimitives';
import cultureImg from '../culture.png';

const checks = [
  'Branded customer app with your colours and offers',
  'Counter billing that uses the same stock as online',
  'Warehouse → branch stock with approvals',
  'Own riders + courier in one delivery flow',
  'Coupons, timer deals, and Free Cash wallet',
  'Returns, refunds, and 1-star review tickets handled',
];

export default function CultureSplit() {
  return (
    <section className="section-pad bg-ink">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <div className="relative z-10">
            <div className="pointer-events-none absolute -inset-2 -z-10 rounded-[1.75rem] bg-accent/10 blur-xl" />
            <img
              src={cultureImg}
              alt="Retail teams with Zuntly"
              width={1536}
              height={1024}
              decoding="async"
              className="img-glow relative z-10 h-auto w-full object-contain"
            />
          </div>
        </Reveal>

        <Reveal delay={0.08}>
          <span className="pill-light">For Your Team</span>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Built for <span className="grad-text">your whole team</span>
          </h2>
          <p className="mt-4 text-mute">
            Owners, managers, packing staff, and riders each see only what they need. Less training,
            fewer mistakes.
          </p>
          <ul className="mt-8 space-y-3">
            {checks.map((item) => (
              <li key={item} className="flex gap-3 text-sm text-white sm:text-base">
                <span className="mt-0.5 text-lg text-emerald-400">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
